import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import { api } from './api'
import { demoReveal } from './demodata'
import * as actions from './actions'
import * as GateSelectors from 'app/modules/gates/selectors'
import * as GateActions from 'app/modules/gates/actions'
import * as TrackingActions from 'app/modules/tracking/actions'
import { startDriftIntelRevealTrial } from 'app/modules/gates/actions'

const fetchRevealDataByIp = (action$, { getState }) => {
  return action$
    .ofType(actions.fetchRevealDataByIp.toString())
    .map(action => action.payload)
    .mergeMap(({ ip }) => {
      if (GateSelectors.hasDemoOrg(getState())) {
        return demoReveal.map(data => actions.fetchRevealDataByIpSuccess({ data, ip }))
      } else {
        return api
          .fetchRevealDataByIp(ip)
          .takeUntil(action$.ofType(actions.fetchRevealDataByIpCancelled({ ip })))
          .map(data => actions.fetchRevealDataByIpSuccess({ data, ip }))
          .startWith(actions.fetchRevealDataByIpPending({ ip }))
          .catch(error => Observable.of(actions.fetchRevealDataByIpFailed({ error, ip })))
      }
    })
}

const fetchRevealData = (action$, { getState }) => {
  return action$
    .ofType(actions.fetchRevealData.toString())
    .pluck('payload')
    .mergeMap(revealOptions => {
      if (GateSelectors.hasDemoOrg(getState())) {
        return demoReveal.map(data => actions.fetchRevealDataSuccess({ data, ...revealOptions }))
      } else {
        return api
          .fetchRevealData(revealOptions)
          .takeUntil(action$.ofType(actions.fetchRevealDataCancelled()))
          .map(data => actions.fetchRevealDataSuccess({ data, ...revealOptions }))
          .startWith(actions.fetchRevealDataPending())
          .catch(error => Observable.of(actions.fetchRevealDataFailed({ error, revealOptions })))
      }
    })
}

const fetchRevealDataBySourceProperties = action$ => {
  return action$
    .ofType(actions.fetchRevealDataBySourceProperties.toString())
    .pluck('payload')
    .mergeMap(revealOptions => {
      return api
        .fetchDriftIntelByEndUserId(revealOptions)
        .takeUntil(action$.ofType(actions.fetchRevealDataCancelled()))
        .map(data => actions.fetchRevealDataSuccess({ data, ...revealOptions }))
        .startWith(actions.fetchRevealDataBySourcePropertiesPending())
        .catch(error => Observable.of(actions.fetchRevealDataFailed({ error, revealOptions })))
    })
}

const trackShowRevealData = action$ =>
  action$
    .ofType(startDriftIntelRevealTrial.toString())
    .map(() => TrackingActions.track('Clearbit Trial Show Button Clicked'))

const enterConversationsRevealTrial = (action$, { getState }) => {
  const hasConversationsRevealTrial = GateSelectors.makeHasGate('has_conversations_reveal_trial')

  return action$
    .ofType(actions.showRevealData.toString())
    .filter(() => !hasConversationsRevealTrial(getState()))
    .map(() => GateActions.startDriftIntelRevealTrial())
}

export const epic = combineEpics(
  fetchRevealData,
  fetchRevealDataByIp,
  fetchRevealDataBySourceProperties,
  trackShowRevealData,
  enterConversationsRevealTrial
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/epic.js